import BVASelect from "../../../components/BVASelect/BVASelect";
import {useState} from "react";
import FinancingCalculator from "./FinancingCalculator";
import GodwillApplication from "./GodwillApplication";
import DealStructure from "./DealStructure";
import ProceedsWorksheet from "./ProceedsWorksheet";
import AcquisitionExpenses from "./AcquisitionExpenses";

const FIANACINGCALCULATOR = "FIANACINGCALCULATOR"
const GOODWILL = "GOODWILL"
const DEALSTRUCTURE = "DEALSTRUCTURE"
const PROCEEDS = "PROCEEDS"
const EXPENSES = "EXPENSES"

const selectSections = [
  { label: "Financing Calculator", value: FIANACINGCALCULATOR },
  { label: "Goodwill Application", value: GOODWILL },
  { label: "Deal Structure", value: DEALSTRUCTURE },
  { label: "Proceeds Worksheet", value: PROCEEDS },
  { label: "Acquisition Expenses", value: EXPENSES },
]

export default function Valuation() {
  // States
  const [selectedSection, setSelectedSection] = useState(FIANACINGCALCULATOR)

  // Methods
  const getSection = () => {
    switch(selectedSection) {
      case FIANACINGCALCULATOR:
        return <FinancingCalculator />

      case GOODWILL:
        return <GodwillApplication />

      case DEALSTRUCTURE:
        return <DealStructure />

      case PROCEEDS:
        return <ProceedsWorksheet />

      case EXPENSES:
        return <AcquisitionExpenses />

      default:
        break
    }
  }

  return (
    <div>
      <div className="flex items-center">
        <BVASelect
            items={selectSections}
            value={selectedSection}
            width="24em"
            placeholder="Select a section"
            onChange={(value) => setSelectedSection(value)} />
      </div>
      <div className="mt-20">
        {getSection()}
      </div>
    </div>
  )
}
